import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { MemberDetailSchema } from './members-access.contract'
import type { CourtesyInput, MemberDetail } from './members-access.contract'
import { membersAccessKeys } from './members-access.queries'

function invalidateMembers(queryClient: ReturnType<typeof useQueryClient>, memberId?: string) {
  void queryClient.invalidateQueries({ queryKey: membersAccessKeys.lists() })
  if (memberId) {
    void queryClient.invalidateQueries({ queryKey: membersAccessKeys.detail(memberId) })
  } else {
    void queryClient.invalidateQueries({ queryKey: membersAccessKeys.details() })
  }
}

export function useCreateCourtesy() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: CourtesyInput) => {
      const data = await apiFetch<unknown>('/members-area/members', { method: 'POST', body })
      return MemberDetailSchema.parse(data)
    },
    onSuccess: (detail) => invalidateMembers(queryClient, detail.id),
  })
}

export function useRevokeGrant() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (grantId: string): Promise<MemberDetail> => {
      const data = await apiFetch<unknown>(`/members-area/grants/${grantId}/revoke`, {
        method: 'POST',
      })
      return MemberDetailSchema.parse(data)
    },
    onSuccess: (detail) => invalidateMembers(queryClient, detail.id),
  })
}

export function useRestoreGrant() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (grantId: string): Promise<MemberDetail> => {
      const data = await apiFetch<unknown>(`/members-area/grants/${grantId}/restore`, {
        method: 'POST',
      })
      return MemberDetailSchema.parse(data)
    },
    onSuccess: (detail) => invalidateMembers(queryClient, detail.id),
  })
}
